import React from 'react'
import {
  AlignItems,
  Box,
  Color,
  Display,
  DisplayPosition,
  FlexDirection,
  FontWeight,
  Heading3,
  Image,
  JustifyContent,
  Overflow,
  Text,
} from '@gousto-internal/citrus-react'
import { getDefaultImage, getSrcSet } from '../../utils'
import { getTileKeyDownHandler } from './shared'
import type { CategoryTileProps } from './shared'

export const PromotedCategoryTile = ({
  title,
  imageCrops = [],
  recipeCount,
  onClick,
}: CategoryTileProps) => (
  <Box
    display={Display.Flex}
    flexDirection={FlexDirection.Column}
    bg={Color.White}
    height="100%"
    role="button"
    tabIndex={0}
    borderRadius={1}
    boxShadow="0 1px 4px rgba(0, 0, 0, 0.08)"
    overflowX={Overflow.Hidden}
    style={{ cursor: 'pointer' }}
    data-testid="category-tile-promoted"
    onClick={onClick}
    onKeyDown={getTileKeyDownHandler(onClick)}
  >
    <Box
      position={DisplayPosition.Relative}
      width="100%"
      height={['128px', '128px', '156px', '192px']}
      flexShrink={0}
    >
      <Image
        src={getDefaultImage(imageCrops)}
        srcSet={getSrcSet(imageCrops)}
        alt={title}
        height="100%"
        width="100%"
        fit="cover"
        style={{
          borderTopRightRadius: '4px',
          borderBottomRightRadius: 0,
          borderTopLeftRadius: '4px',
          borderBottomLeftRadius: 0,
        }}
      />
      <Box
        position={DisplayPosition.Absolute}
        bg={Color.ColdGrey_50}
        style={{ borderRadius: '4px' }}
        display={Display.Flex}
        alignItems={AlignItems.Center}
        justifyContent={JustifyContent.Center}
        paddingV={0.5}
        paddingH={1}
        bottom={['6px', '6px', '8px']}
        right={['6px', '6px', '8px']}
      >
        <Text color={Color.ColdGrey_800} fontWeight={FontWeight.Bold} size={[0, 0, 1]}>
          {recipeCount}
        </Text>
      </Box>
    </Box>
    <Box paddingH={2} paddingV={[2, 2, 3]} display={Display.Flex} alignItems={AlignItems.FlexStart}>
      <Heading3 color={Color.ColdGrey_900} fontWeight={FontWeight.Bold} size={[3, 3, 4, 6]}>
        {title}
      </Heading3>
    </Box>
  </Box>
)
